import api from '../../api'

export const longRunningTasksEndpoint = '/web/admin/long-running-tasks'
export const longRunningTaskEndpoint = (id: number) => `${longRunningTasksEndpoint}/${id}`
export const cancelLongRunningTaskEndpoint = (id: number) => `${longRunningTasksEndpoint}/${id}/cancel`
export const resumeLongRunningTaskEndpoint = (id: number) => `${longRunningTasksEndpoint}/${id}/resume`
export const createJobRefreshTaskEndpoint = `${longRunningTasksEndpoint}/job-refresh`

export type TaskStatus = 'Pending' | 'Running' | 'Completed' | 'Failed' | 'Cancelled'

export type RunOutcome = 'Launching' | 'Running' | 'Completed' | 'Failed' | 'Cancelled' | 'NotClaimed' | 'Lost'

export type LongRunningTask = {
  id: number
  taskType: string
  parameters: string
  status: TaskStatus
  currentRunId: number | null
  resumeCursor: string | null
  processedCount: number
  failedCount: number
  estimatedTotal: number | null
  statusDetail: string | null
  lastError: string | null
  heartbeatAt: string | null
  lastProgressAt: string | null
  cancelRequestedAt: string | null
  cancelRequestedBy: string | null
  createdAt: string
  createdBy: string
  startedAt: string | null
  completedAt: string | null
  updatedAt: string
}

export type LongRunningTaskSummary = {
  task: LongRunningTask
  isHeartbeatStale: boolean
  isStalled: boolean
  createdByEmail: string | null
  cancelRequestedByEmail: string | null
}

export type LongRunningTaskRun = {
  id: number
  taskId: number
  ecsTaskArn: string | null
  version: string | null
  outcome: RunOutcome
  exitCode: number | null
  stoppedReason: string | null
  launchedAt: string
  launchedBy: string
  startedAt: string | null
  endedAt: string | null
}

export type LongRunningTaskRunDetails = {
  run: LongRunningTaskRun
  launchedByEmail: string | null
}

export type LongRunningTaskFailure = {
  id: number
  taskId: number
  runId: number
  itemKey: string
  error: string
  failedAt: string
}

export type LongRunningTaskDetails = {
  summary: LongRunningTaskSummary
  runs: LongRunningTaskRunDetails[]
  failures: LongRunningTaskFailure[]
}

export type LaunchResult = {
  localCommand: string | null
  launchError: string | null
}

export type CreateTaskResult = LaunchResult & {
  task: LongRunningTask
}

export type ResumeTaskResult = LaunchResult & {
  task: LongRunningTask | null
}

export type JobRefreshParameters = {
  maxJobs: number | null
  tenantId: number | null
  startJobId: number | null
  endJobId: number | null
}

export const listLongRunningTasks = async (status?: TaskStatus): Promise<LongRunningTaskSummary[]> => {
  return (await api.get(longRunningTasksEndpoint, { params: { status } })).data
}

export const getLongRunningTask = async (id: number): Promise<LongRunningTaskDetails> => {
  return (await api.get(longRunningTaskEndpoint(id))).data
}

export const cancelLongRunningTask = async (id: number): Promise<void> => {
  await api.post(cancelLongRunningTaskEndpoint(id))
}

export const resumeLongRunningTask = async (id: number): Promise<ResumeTaskResult> => {
  return (await api.post(resumeLongRunningTaskEndpoint(id))).data
}

export const createJobRefreshTask = async (parameters: JobRefreshParameters): Promise<CreateTaskResult> => {
  return (await api.post(createJobRefreshTaskEndpoint, parameters)).data
}
